var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "section" },
    [
      _c("span", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("RailwayExport.FirstLeglastLegInformation")))
      ]),
      _c("cargo-ag-grid", {
        staticStyle: {},
        attrs: {
          "grid-options": _vm.gridOptions,
          "column-defs": _vm.columnDefs,
          "row-data": _vm.finalRowData
        },
        on: {
          gridReady: function(params) {
            _vm.gridApi = params.api
          }
        }
      }),
      _c(
        "div",
        { staticClass: "operations", staticStyle: { "margin-top": "5px" } },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.cooperateEdit,
                  expression: "cooperateEdit"
                }
              ],
              staticClass: "triggers"
            },
            [
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "copyAndAddPoItems",
                        type: "primary",
                        disabled: _vm.readonly
                      },
                      on: { click: _vm.copyNewHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.copyAndAddPoItems")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "Add",
                        type: "primary",
                        disabled: _vm.readonly
                      },
                      on: { click: _vm.addHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Add2")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "Delete",
                        type: "danger",
                        disabled: _vm.notEdit
                      },
                      on: { click: _vm.delHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Delete")))]
                  )
                ],
                1
              )
            ]
          )
        ]
      ),
      _c(
        "el-form",
        {
          staticStyle: { "margin-top": "15px" },
          attrs: {
            disabled: _vm.notEdit,
            "label-width": "70px",
            "label-position": "left"
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("RailwayExport.FirstLeglastLeg") } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "190px" },
                  attrs: {
                    no: "headwayTail",
                    placeholder: _vm.notEdit
                      ? ""
                      : _vm.$t("CargoMsg.Cargo_PleaseSelect")
                  },
                  on: { change: _vm.onFormChange },
                  model: {
                    value: _vm.form.headwayTail,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "headwayTail", $$v)
                    },
                    expression: "form.headwayTail"
                  }
                },
                _vm._l(_vm.HEADWAY_TAIL_TYPES, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.chineseName, value: item.code }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("RailwayExport.TransportationMethod") } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "190px" },
                  attrs: {
                    no: "transportMethod",
                    placeholder: _vm.notEdit
                      ? ""
                      : _vm.$t("CargoMsg.Cargo_PleaseSelect")
                  },
                  on: { change: _vm.onFormChange },
                  model: {
                    value: _vm.form.transportMethod,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "transportMethod", $$v)
                    },
                    expression: "form.transportMethod"
                  }
                },
                _vm._l(_vm.TRANSPORT_METHOD_TYPES, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.chineseName, value: item.code }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "auto-width",
              attrs: { label: _vm.$t("SeaExport.HaulageCompany") }
            },
            [
              _c("cargo-company-select", {
                staticStyle: { display: "block", width: "280px" },
                attrs: {
                  no: "transportCompany",
                  "method-params": { truckCmp: true, active: true },
                  "default-value": _vm.form.transportCompany || ""
                },
                on: {
                  change: function(p) {
                    _vm.form.transportCompany = p.value
                    _vm.onFormChange()
                  }
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { display: "flex", "flex-direction": "row" } },
        [
          _c(
            "el-form",
            {
              attrs: {
                disabled: _vm.notEdit,
                "label-width": "70px",
                "label-position": "left"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.Trucking") } },
                [
                  _c("cargo-advance-select", {
                    staticStyle: { width: "190px" },
                    attrs: {
                      no: "region",
                      "select-type": _vm.TYPE_NAMES.basic_data_Country,
                      "default-value": _vm.form.region,
                      filterable: ""
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.region = p.value
                        _vm.onFormChange()
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form",
            {
              staticStyle: { width: "fit-content", "margin-left": "30px" },
              attrs: {
                disabled: _vm.notEdit,
                inline: true,
                "label-position": "left"
              }
            },
            [
              _c("cargo-area", {
                attrs: {
                  no: "province",
                  country: "CN",
                  province: _vm.form.province,
                  city: _vm.form.city,
                  district: _vm.form.districts
                },
                on: {
                  "update:province": function($event) {
                    return _vm.$set(_vm.form, "province", $event)
                  },
                  "update:city": function($event) {
                    return _vm.$set(_vm.form, "city", $event)
                  },
                  "update:district": function($event) {
                    return _vm.$set(_vm.form, "districts", $event)
                  }
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-form",
        {
          staticStyle: { width: "fit-content" },
          attrs: {
            disabled: _vm.notEdit,
            inline: true,
            "label-width": "70px",
            "label-position": "left"
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("RailwayExport.ContactPerson") } },
            [
              _c("el-input", {
                attrs: { no: "contact" },
                on: { change: _vm.onFormChange },
                model: {
                  value: _vm.form.contact,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "contact", $$v)
                  },
                  expression: "form.contact"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: { label: _vm.$t("SeaExport.Tel"), "label-width": "36px" }
            },
            [
              _c("el-input", {
                attrs: { no: "telephone" },
                on: { change: _vm.onFormChange },
                model: {
                  value: _vm.form.telephone,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "telephone", $$v)
                  },
                  expression: "form.telephone"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-form",
        {
          attrs: {
            disabled: _vm.notEdit,
            "label-width": "70px",
            "label-position": "left"
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("RailwayExport.DetailedAddress") } },
            [
              _c("el-input", {
                staticStyle: { width: "637px" },
                attrs: { no: "address", type: "textarea", rows: 3 },
                on: { change: _vm.onFormChange },
                model: {
                  value: _vm.form.address,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "address", $$v)
                  },
                  expression: "form.address"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("SeaExport.AdditionalNotes") } },
            [
              _c("el-input", {
                staticStyle: { width: "637px" },
                attrs: { no: "remarks", type: "textarea", rows: 3 },
                on: { change: _vm.onFormChange },
                model: {
                  value: _vm.form.remarks,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "remarks", $$v)
                  },
                  expression: "form.remarks"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }